import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-down",
  "use": "icon-a-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down\" id=\"icon-a-down\"><line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\" /><polyline points=\"19 12 12 19 5 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol